import { Input } from 'components/elements';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export default function InformationField() {
  const { t } = useTranslation();

  return (
    <FullContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            name="code"
            type="text"
            label={t('common:code')}
            placeholder={t('common:code')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="description"
            label={t('common:description')}
            placeholder={t('common:description')}
          />
        </HalfContainer>
      </SectionContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name="name"
            label={t('common:product')}
            placeholder={t('common:product')}
            required
          />
        </HalfContainer>
      </SectionContainer>
    </FullContainer>
  );
}
